import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_SESSION_SECRET || "default-unsafe-key";

// Encrypt and store in localStorage
export function setSecureLocalItem(key, value) {
  try {
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(value), SECRET_KEY).toString();
    localStorage.setItem(key, encrypted);
    return true;
  } catch (error) {
    console.error("Error saving to localStorage:", error);
    return false;
  }
}

// Decrypt and retrieve from localStorage
export function getSecureLocalItem(key) {
  try {
    const encrypted = localStorage.getItem(key);
    if (!encrypted) return null;

    const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    console.log(decrypted, 'decrypted --->', key);
    return JSON.parse(decrypted);
  } catch (error) {
    console.error("Error reading from localStorage:", error);
    return null;
  }
}

// Remove from localStorage
export function removeSecureLocalItem(key) {
  localStorage.removeItem(key);
}













//HOW TO USE THIS HERE

// import { setSecureSessionItem, getSecureSessionItem, removeSecureSessionItem } from '../utils/secureSessionStorage';

// Save
// setSecureSessionItem('userSettings', { theme: 'dark' });

// Retrieve
// const settings = getSecureSessionItem('userSettings');

// Remove
// removeSecureSessionItem('userSettings');